var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "waba-supsis-auth-intl-price-eligibility-update" },
    [
      _c("div", { staticClass: "title" }, [
        _vm._v(
          _vm._s(
            _vm.$t(
              "auto.whatsappBusinessApiV2InternationalPriceEligibilityUpdate"
            )
          )
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "meta" }, [
        _c("div", [
          _c("b", [_vm._v(_vm._s(_vm.$t("auto.event")))]),
          _vm._v(": " + _vm._s(_vm.$_.get(_vm.activity, "payload.event"))),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("b", [_vm._v(_vm._s(_vm.$t("auto.channelId")))]),
          _vm._v(": " + _vm._s(_vm.$_.get(_vm.activity, "payload.channelId"))),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("b", [_vm._v(_vm._s(_vm.$t("auto.startTime")))]),
          _vm._v(
            ": " +
              _vm._s(
                _vm.$_.get(
                  _vm.activity,
                  "payload.auth_international_rate_eligibility.start_time"
                )
              )
          ),
        ]),
        _vm._v(" "),
        _vm.exceptionCountries.length > 0
          ? _c("div", [
              _c("b", [_vm._v(_vm._s(_vm.$t("auto.exceptionCountries")))]),
              _vm._v(":\n            "),
              _c(
                "ul",
                _vm._l(_vm.exceptionCountries, function (country, index) {
                  return _c("li", { key: index }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(country.country_code) +
                        " (" +
                        _vm._s(_vm.$t("auto.startTime")) +
                        ": " +
                        _vm._s(country.start_time) +
                        ")\n                "
                    ),
                  ])
                }),
                0
              ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("details", { staticClass: "raw" }, [
        _c("summary", [_vm._v(_vm._s(_vm.$t("auto.rawPayload")))]),
        _vm._v(" "),
        _c("pre", [_vm._v(_vm._s(_vm.prettyPayload))]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }